// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_home_home_module_ts":"6adb5918af225c3c","src_app_features_dashboard_dashboard_module_ts":"6297a962305bdf10","src_app_features_submenu_submenu_module_ts":"35c72286c36da786"}[chunkId] + ".js";
};